module.exports = __webpack_public_path__ + "img/19.8b5dfbb0.jpg";